export const CJ_COOKIE_NAME = 'cje'

export const CJ_EVENT_QUERY_PARAM = 'cjevent'

export const CJ_AID_COOKIE_NAME = 'aid'

export const CJ_AID_QUERY_PARAM = 'aid'

export const CJ_AID_FALLBACK_QUERY_PARAM = 'utm_term'

export const CJ_PID_COOKIE_NAME = 'pid'

export const CJ_PID_QUERY_PARAM = 'pid'

export const CJ_PID_FALLBACK_QUERY_PARAM = 'utm_content'

export const CJ_APPSFLYER_ID_COOKIE_NAME = 'appsflyer_id'

export const CJ_EVENT_MAX_LENGTH = 255

export const CJ_FIELD_VALUE_PATTERN = /^[-0-9A-Za-z_]+$/
